import { SentimentWordConfig } from './types';

export const zhSentimentWordConfig: SentimentWordConfig = {
    positiveWords: new Set([
        '好',
        '很好',
        '优秀',
        '完成',
        '成功',
        '安全',
        '稳定',
        '改善',
        '解决',
        '准备',
        '进展',
        '成长',
        '开心',
        '快乐',
        '有用',
        '清晰',
        '安心',
        '健康',
        '支持',
        '胜利',
        '恢复',
        '顺利',
        '希望',
        '积极',
        '完整',
        '提升',
        '可靠',
        '值得',
        '平稳',
        '放心',
        '喜悦',
        '喜爱',
        '圆满',
        '奋进',
        '出色',
        '前进',
        '友好',
        '喜讯',
        '复原',
        '宽心',
        '明朗',
        '欣慰',
        '热爱',
        '满意',
        '振奋',
        '提升了',
        '放心了',
        '有益',
        '朝气',
        '正向',
        '稳固',
        '美好',
        '自信',
        '获胜',
        '轻松',
        '顺畅',
        '鼓舞',
        '齐全',
        '安宁',
        '安心',
        '称心',
        '畅快',
        '充实',
        '得力',
        '得胜',
        '敦厚',
        '发光',
        '丰收',
        '和谐',
        '欢欣',
        '欢喜',
        '坚实',
        '简明',
        '康复',
        '可喜',
        '可亲',
        '靠谱',
        '乐观',
        '利好',
        '明快',
        '宁静',
        '平安',
        '齐心',
        '庆祝',
        '舒心',
        '爽快',
        '顺心',
        '踏实',
        '完备',
        '温和',
        '无忧',
        '向好',
        '欣喜',
        '兴旺',
        '愉快',
        '真诚',
        '振作',
        '周全',
        '助力',
        '尊重',
    ]),
    negativeWords: new Set([
        '坏',
        '糟糕',
        '最差',
        '失败',
        '故障',
        '问题',
        '危险',
        '不安',
        '延迟',
        '缓慢',
        '紧急',
        '风险',
        '漏洞',
        '错误',
        '混乱',
        '悲伤',
        '威胁',
        '危机',
        '拒绝',
        '回退',
        '停滞',
        '担心',
        '困难',
        '崩溃',
        '痛苦',
        '讨厌',
        '恶化',
        '阻塞',
        '脆弱',
        '卡住',
        '不顺',
        '不稳',
        '不良',
        '丑陋',
        '严峻',
        '受阻',
        '危险性',
        '压抑',
        '受伤',
        '可怕',
        '吓人',
        '堆积',
        '失控',
        '失落',
        '头疼',
        '威吓',
        '尴尬',
        '崩坏',
        '忧虑',
        '恼火',
        '恶劣',
        '慌乱',
        '挫败',
        '损坏',
        '有害',
        '棘手',
        '沮丧',
        '焦虑',
        '疲惫',
        '糟',
        '落后',
        '虚弱',
        '警报',
        '负面',
        '麻烦',
        '哀伤',
        '败坏',
        '别扭',
        '沉重',
        '迟缓',
        '冲突',
        '低迷',
        '低效',
        '堵塞',
        '发愁',
        '烦躁',
        '费劲',
        '负担',
        '寒心',
        '后退',
        '坏掉',
        '紧张感',
        '纠结',
        '哭泣',
        '困扰',
        '狼狈',
        '落空',
        '疲弱',
        '破损',
        '压迫',
        '隐患',
        '杂乱',
        '折磨',
        '致命',
        '窒碍',
        '重压',
        '阻碍',
        '走低',
        '作痛',
        '失常',
    ]),
};
